import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import Avatar from '@material-ui/core/Avatar'
import Button from '@material-ui/core/Button'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import CardActions from '@material-ui/core/CardActions'
import CardHeader from '@material-ui/core/CardHeader'
import Collapse from '@material-ui/core/Collapse'
import FormControl from '@material-ui/core/FormControl'
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'
import IconButton from '@material-ui/core/IconButton'
import SendIcon from '@material-ui/icons/Send'
import PeopleIcon from '@material-ui/icons/People'
import { ChatMenu, UserListDialog, Word } from '../../../containers'
import { WID, getWord } from '../../../constants/Language';
import CustomAvatar from '../../../Parts/CustomAvatar/CustomAvatar'

const styles = theme => ({
  button: {
  },
  card: {
    marginTop: theme.spacing.unit,
    marginRight: 'auto',
    marginBottom: theme.spacing.unit,
    marginLeft: 'auto',
  },
  cardHeader: {
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    backgroundColor: theme.palette.grey[100],
  },
  cardContent: {
    height: '150px',
    overflowY:'scroll',
  },
  cardActions: {
    display: 'flex',
    paddingTop: theme.spacing.unit / 2,
    paddingBottom: theme.spacing.unit / 2,
    justifyContent: 'flex-end',
    backgroundColor: theme.palette.grey[100],
  },
  textField: {
    width: '100%',
    maxWidth: '250px', 
  },
  messageBox: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing.unit,
  },
  displayName: {
    display: 'inline-block',
    maxWidth: '100px',
    marginRight: theme.spacing.unit,
    color: theme.palette.grey[600],
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    verticalAlign: 'middle',
  },
  message: {
  },
  boardButton: {
    display:'inline-block',
    verticalAlign: 'middle',
  },
  avatar: {
    width: 24,
    height: 24,
    marginRight: theme.spacing.unit,
    fontSize: '1em',
  },
  avatarPrimary: {
    width: 24,
    height: 24,
    marginRight: theme.spacing.unit,
    fontSize: '1em',
    backgroundColor: theme.palette.primary.light,
  },
  action: {
    display: 'flex',
    alignItems: 'center',
  },
  peopleIcon: {
    color: theme.palette.grey[500],
    margin: theme.spacing.unit,
  },
  totalUser: {
    color: theme.palette.grey[500],
  }
})

class ChatCard extends React.Component {

  componentDidUpdate(){
    setTimeout(() => {
      var obj = document.getElementById('chat-live-' + this.props.liveId)
      if (obj) {
        obj.scrollTop = obj.scrollHeight
      }
    }, 0)
  }

  render() {
    const { classes, bid, liveId, disabledSendButton, message, chatRoom, isVisibleChatCard, handleTextChange, handleClickSendButton, handleOpenBoard, handleKeyDown, language } = this.props
    var avatar
    return (
      <div>
        <Card className={classes.card}>
          <CardHeader
            className={classes.cardHeader}
            subheader={<Word wid={WID.CHAT_CARD.CARD_TITLE}/>}
            action={
              <div className={classes.action}>
                {chatRoom && chatRoom.totalUser && (
                  <React.Fragment>
                    <PeopleIcon className={classes.peopleIcon}/>
                    <Typography className={classes.totalUser}>{chatRoom.totalUser}</Typography>
                  </React.Fragment>
                )}
                <ChatMenu bid={bid} liveId={liveId}/>
              </div>
            }
          >
          </CardHeader>
          <Collapse in={isVisibleChatCard}>
            <CardContent className={classes.cardContent} id={'chat-live-' + liveId}>
            {chatRoom && chatRoom.chat.map((chat, index) => {
              if (chat.photoURL) {
                avatar = (<CustomAvatar className={classes.avatar} src={chat.photoURL} name={chat.displayName}/>)
              }
              else if (!chat.photoURL && chat.displayName && !chat.displayName.match(/guest[0-9]*/)) {
                avatar = (<Avatar className={classes.avatarPrimary}>{chat.displayName[0].toUpperCase()}</Avatar>)
              }
              else if (!chat.photoURL && chat.displayName && chat.displayName.length > 0) {
                avatar = (<CustomAvatar className={classes.avatar} name={chat.displayName}/>)
              }
              else {
                avatar = (<Avatar className={classes.avatar}></Avatar>)
              }
              return (
                <div className={classes.messageBox} key={index}>
                  {avatar}
                  <Typography>
                    <span className={classes.displayName}>{chat.displayName}</span>
                    <span className={classes.message}>{chat.message}</span>
                    {chat.boardContext && chat.message === '' && (
                      <Button className={classes.boardButton} color="primary" onClick={handleOpenBoard(chat.boardContext, chat.analyzeId, language)}>
                        <Word wid={WID.CHAT_CARD.ANALYSIS_BOARD}/> {chat.analyzeId}
                      </Button>
                    )}
                  </Typography>
                </div>
              )})}
            </CardContent>
            <CardActions className={classes.cardActions}>
              <FormControl>
              <TextField
                className={classes.textField}
                placeholder={getWord(WID.CHAT_CARD.ENTER_A_MESSAGE, language)}
                value={message}
                onChange={handleTextChange('message')}
                onKeyDown={handleKeyDown}
              />
              </FormControl>
              <IconButton
                className={classes.button}
                color="primary"
                disabled={disabledSendButton}
                onClick={handleClickSendButton}
              >
                <SendIcon className={classes.icon}/>
              </IconButton>
            </CardActions>
          </Collapse>
        </Card>
        {chatRoom && chatRoom.users && (
          <UserListDialog users={chatRoom.users}/>
        )}
      </div>
    )
  }
}

export default withStyles(styles)(ChatCard)



// WEBPACK FOOTER //
// ./src/components/Common/Chat/ChatCard.js